import APIService from './class';

class Incentives extends APIService {
  constructor() {
    super( '/incentive' );
  }
}

export default new Incentives();
